import {Injectable} from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({
  providedIn: 'root'
})
export class SupInviteService extends BaseService {
  constructor(http:HttpClient) {
    super(http);
  }

  private url = 'api/sup-invite';

  getUrl():string {
    return this.url;
  }


  resend(ids):Observable<any> {
    const url = `${this.getUrl()}/resend`;
    return this.http.get<any>(url, {params: {id: ids}}).pipe(
      tap(_ => this.log(`resend`)),
      catchError(this.handleError<any>(`resend`))
    );
  }

  relateSupplier(inviteId,supplierId):Observable<any> {
    const url = `${this.getUrl()}/relate-supplier`;
    return this.http.get<any>(url, {params: {inviteId: inviteId,supplierId:supplierId}}).pipe(
      tap(_ => this.log(`relate-supplier`)),
      catchError(this.handleError<any>(`relate-supplier`))
    );
  }
}
